import Model, { Request } from '../model'

export default class ServiceCategory extends Model {
  static modelName () {
    return 'serviceCategory'
  }

  objectID () {
    return this.idServiceCategory
  }

  addPhoto (image, options) {
    const url = this.constructor.modelBaseURL() + '/' + this.objectID() + '/addPhoto'

    const formData = new FormData()
    formData.append('image', image)

    const request = Request.post(url, formData)
    request.options = options
    return this.constructor.requestItem(request, this.constructor)
  }

  deletePhoto () {
    const url = this.constructor.modelBaseURL() + '/' + this.objectID() + '/deletePhoto'
    return this.constructor.requestItem(Request.get(url), this.constructor)
  }

  get image () {
    if (this.hasImage) {
      return this.images.square
    }

    return null
  }

  get initials () {
    return this.name?.charAt(0).toUpperCase()
  }

  get description () {
    return this.title
  }
}
